export default __webpack_public_path__ + "1aaef9dd7478126a5e669a7f0cd8552a.png";